import React, { createContext, useContext, useEffect, useState } from "react";
import { api, getToken, setToken } from "./api";

const Ctx = createContext(null);
export const useAuth = () => useContext(Ctx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anon, obj = authed

  useEffect(() => {
    (async () => {
      if (!getToken()) { setUser(false); return; }
      try { setUser(await api("GET", "/auth/me")); }
      catch (err) { console.error("Session restore failed:", err); setToken(""); setUser(false); }
    })();
  }, []);

  const login = async (email, password) => {
    const r = await api("POST", "/auth/login", { email, password });
    setToken(r.token); setUser(r.user); return r.user;
  };
  const logout = () => { setToken(""); setUser(false); };

  return <Ctx.Provider value={{ user, setUser, login, logout }}>{children}</Ctx.Provider>;
}
